var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.stornierung && _vm.kostenlosStornierbar)?_c('div',{staticClass:"alert alert-success text-left",domProps:{"innerHTML":_vm._s(
    _vm.stornierungKostenString ?
      _vm.$t('stornierung.kostenfrei_bis', {
        datum: _vm.stornierungKostenfreiBisString,
        betrag: _vm.stornierungKostenString,
      })
    :
      _vm.$t('stornierung.kostenfrei_bis_ohne', {
        datum: _vm.stornierungKostenfreiBisString
      })
  )}}):(_vm.stornierung && !_vm.kostenlosStornierbar)?_c('div',{staticClass:"alert alert-warning text-left",domProps:{"innerHTML":_vm._s(
    _vm.stornierungKostenString ?
      _vm.$t('stornierung.nicht_kostenfrei', { betrag: _vm.stornierungKostenString })
    :
      _vm.$t('stornierung.nicht_kostenfrei_ohne')
  )}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }